(function () {
	'use strict';

	angular
		.module('directives')
		.directive('compareDateWith', compareDateWith);

	compareDateWith.$inject = ['$filter', '$locale'];

	function compareDateWith($filter, $locale) {
		var directive = {
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, ctrl) {
			var validate = function (viewValue) {
				// This directive may not work in certain locales
				// be careful if you intend to use it
				var comparisonModel = $filter('date')($attrs.compareDateWith, 'yyyy-MM-dd');
				var localeDate = moment(viewValue, 'LL', $locale.id);

				var viewTemp = $filter('date')(localeDate.isValid() ? localeDate.toDate() : viewValue, 'yyyy-MM-dd');
				if (!viewValue || !comparisonModel) {
					// It's valid because there is no comparison
					ctrl.$setValidity('compareDateWith', true);
					return viewValue;
				}
				//Implement other operators as needed (lt, lte, gt, gte, eq, noteq)
				switch ($attrs.operator) {
				case 'gte':
					if ($attrs.offsetDays) {
						ctrl.$setValidity('compareDateWith', moment(viewTemp).diff(moment(comparisonModel).add($attrs.offsetDays, 'days')) >= 0);
					} else {
						ctrl.$setValidity('compareDateWith', moment(viewTemp).diff(moment(comparisonModel)) >= 0);
					}
					break;
				case 'lt':
					ctrl.$setValidity('compareDateWith', moment(viewTemp).diff(moment(comparisonModel)) < 0);
				}
				return viewValue;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('compareDateWith', function (comparisonModel) {
				return validate(ctrl.$viewValue);
			});
		}
	}
})();
